module.exports = __webpack_public_path__ + "img/doc.f8c33863.svg";